import React from 'react';

import { Alert } from 'Components/Partials';
import { FormHandler, Input, Label } from 'Components/Form';

import { Button } from './';
import ScoresApi from "Services/Api/Site/Scores";

const SubmitScore = ({ setScreen, handleSubmit, handleInput, alert, working, form, score }) => {
    const handleRequest = (form) => ScoresApi.post(null, {
        ...form,
        game_id: 'hazard_perception',
        score: 30 - score,
    });

    const handleSuccess = () => setScreen('leaderboard');

    return (
        <form onSubmit={(e) => handleSubmit(e, handleRequest, handleSuccess)}>
            <p className="text-app-yellow nobblee-regular uppercase text-lg text-center lg:text-left font-think w-full mb-5">
                Submit Identity
            </p>

            {alert !== null && (<Alert {...alert} />)}

            <RenderInput
                name="nickname"
                label="Nickname"
                value={form.nickname}
                handleInput={handleInput}
            />

            <RenderInput
                name="employee_number"
                label="Employee No"
                value={form.employee_number}
                handleInput={handleInput}
            />

            <div className="flex flex-col md:flex-row justify-center items-center lg:justify-start gap-5 my-5">
                <Button working={working} size="small">
                    Save Score
                </Button>

                <div
                    className="text-white cursor-pointer"
                    onClick={handleSuccess}
                >
                    Don't Save Score
                </div>
            </div>
        </form>
    );
};

const RenderInput = ({ name, label, handleInput, value }) => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-2 mb-4">
            <div>
                <Label
                    htmlFor={name}
                    className="text-sm xl:text-base my-auto"
                    textColor="text-white"
                    label={label}
                />
            </div>

            <div className="col-span-2">
                <Input
                    containerClassName="mt-0 w-full text-xs text-black"
                    id={name}
                    value={value ?? null}
                    onChange={v => handleInput(name, v)}
                />
            </div>
        </div>
    );
};

export default FormHandler(SubmitScore);
